import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  admin,
  gpay,
  otherbg,
  paytm,
  phonepay,
  wallet,
  qrImage,
  accWallet,
} from "../../assets/img";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import Loader from "../../Component/Loader";
import { Toast } from "../../Component/Toast";
import useStore from "../../LocalStore/useStore";
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import CustomScroll from "../../Component/CustomScroll";
import { MaskIcon } from "../MaskIcon";

const cropperStyles = `
  .cropper-container {
    direction: ltr;
    font-size: 0;
    line-height: 0;
    position: relative;
    touch-action: none;
    user-select: none;
  }

  .cropper-container img {
    display: block;
    height: 100%;
    image-orientation: 0deg;
    max-height: none !important;
    max-width: none !important;
    min-height: 0 !important;
    min-width: 0 !important;
    width: 100%;
  }

  .cropper-wrap-box,
  .cropper-canvas,
  .cropper-drag-box,
  .cropper-crop-box,
  .cropper-modal {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  .cropper-wrap-box,
  .cropper-canvas {
    overflow: hidden;
  }

  .cropper-drag-box {
    background-color: #fff;
    opacity: 0;
  }

  .cropper-modal {
    background-color: #000;
    opacity: 0.5;
  }

  .cropper-view-box {
    display: block;
    height: 100%;
    outline: 1px solid #39f;
    outline-color: rgba(51, 153, 255, 0.75);
    overflow: hidden;
    width: 100%;
  }

  .cropper-dashed {
    border: 0 dashed #eee;
    display: block;
    opacity: 0.5;
    position: absolute;
  }

  .cropper-dashed.dashed-h {
    border-bottom-width: 1px;
    border-top-width: 1px;
    height: calc(100% / 3);
    left: 0;
    top: calc(100% / 3);
    width: 100%;
  }

  .cropper-dashed.dashed-v {
    border-left-width: 1px;
    border-right-width: 1px;
    height: 100%;
    left: calc(100% / 3);
    top: 0;
    width: calc(100% / 3);
  }

  .cropper-center {
    display: block;
    height: 0;
    left: 50%;
    opacity: 0.75;
    position: absolute;
    top: 50%;
    width: 0;
  }

  .cropper-center:before,
  .cropper-center:after {
    background-color: #eee;
    content: ' ';
    display: block;
    position: absolute;
  }

  .cropper-center:before {
    height: 1px;
    left: -3px;
    top: 0;
    width: 7px;
  }

  .cropper-center:after {
    height: 7px;
    left: 0;
    top: -3px;
    width: 1px;
  }

  .cropper-face,
  .cropper-line,
  .cropper-point {
    display: block;
    height: 100%;
    opacity: 0.1;
    position: absolute;
    width: 100%;
  }

  .cropper-face {
    background-color: #fff;
    left: 0;
    top: 0;
  }

  .cropper-line {
    background-color: #39f;
  }

  .cropper-line.line-e {
    cursor: ew-resize;
    right: -3px;
    top: 0;
    width: 5px;
  }

  .cropper-line.line-n {
    cursor: ns-resize;
    height: 5px;
    left: 0;
    top: -3px;
  }

  .cropper-line.line-w {
    cursor: ew-resize;
    left: -3px;
    top: 0;
    width: 5px;
  }

  .cropper-line.line-s {
    bottom: -3px;
    cursor: ns-resize;
    height: 5px;
    left: 0;
  }

  .cropper-point {
    background-color: #39f;
    height: 5px;
    opacity: 0.75;
    width: 5px;
  }

  .cropper-point.point-e {
    cursor: ew-resize;
    margin-top: -3px;
    right: -3px;
    top: 50%;
  }

  .cropper-point.point-n {
    cursor: ns-resize;
    left: 50%;
    margin-left: -3px;
    top: -3px;
  }

  .cropper-point.point-w {
    cursor: ew-resize;
    left: -3px;
    margin-top: -3px;
    top: 50%;
  }

  .cropper-point.point-s {
    bottom: -3px;
    cursor: ns-resize;
    left: 50%;
    margin-left: -3px;
  }

  .cropper-point.point-ne {
    cursor: nesw-resize;
    right: -3px;
    top: -3px;
  }

  .cropper-point.point-nw {
    cursor: nwse-resize;
    left: -3px;
    top: -3px;
  }

  .cropper-point.point-sw {
    bottom: -3px;
    cursor: nesw-resize;
    left: -3px;
  }

  .cropper-point.point-se {
    bottom: -3px;
    cursor: nwse-resize;
    right: -3px;
    height: 20px;
    opacity: 1;
    width: 20px;
  }

  @media (min-width: 768px) {
    .cropper-point.point-se {
      height: 15px;
      width: 15px;
    }
  }

  @media (min-width: 992px) {
    .cropper-point.point-se {
      height: 10px;
      width: 10px;
    }
  }

  @media (min-width: 1200px) {
    .cropper-point.point-se {
      height: 5px;
      opacity: 0.75;
      width: 5px;
    }
  }

  .cropper-point.point-se:before {
    background-color: #39f;
    bottom: -50%;
    content: ' ';
    display: block;
    height: 200%;
    opacity: 0;
    position: absolute;
    right: -50%;
    width: 200%;
  }

  .cropper-invisible {
    opacity: 0;
  }

  .cropper-bg {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
  }

  .cropper-hide {
    display: block;
    height: 0;
    position: absolute;
    width: 0;
  }

  .cropper-hidden {
    display: none !important;
  }

  .cropper-move {
    cursor: move;
  }

  .cropper-crop {
    cursor: crosshair;
  }

  .cropper-disabled .cropper-drag-box,
  .cropper-disabled .cropper-face,
  .cropper-disabled .cropper-line,
  .cropper-disabled .cropper-point {
    cursor: not-allowed;
  }
`;

const Wallet = () => {
  const { kv, set } = useStore();
  const [qrImages, setQrImages] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [isEditableQr, setIsEditableQr] = useState(false);
  const [loading, setLoading] = useState(false);
  const totalWallet = kv?.walletAmount ?? 0;
  // const [totalWallet, setTotalWallet] = useState(0);
  // Cropper.js states
  const [cropperModal, setCropperModal] = useState(false);
  const [cropperImage, setCropperImage] = useState(null);
  const [cropperInstance, setCropperInstance] = useState(null);
  const [croppingFor, setCroppingFor] = useState(null); // 'qr1' or 'qr2'
  const cropperImageRef = useRef(null);
  const fileInputRef1 = useRef(null);
  const [check, setCheck] = useState(false);

  const bank_obj = kv.bank_obj || {
    acc_no: "",
    ifsc_code: "",
    acc_holder: "",
    upi_type: "gpay",
    upi_id: "",
  };
  const [formData, setFormData] = useState(
    bank_obj ?? {
      acc_no: "",
      ifsc_code: "",
      acc_holder: "",
      upi_type: "gpay",
      upi_id: "",
    },
  );

  const userId = localStorage.getItem("user_id");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (!isEditable) return; // prevent typing if fields are disabled
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setCropperImage(e.target.result);
        setCroppingFor("qr1");
        setCropperModal(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchBankDetails = async () => {
    let val_load = Object.values(bank_obj).some((val) => val == "");
    if (val_load) {
      // setLoading(true);
    }

    try {
      const res = await get(URLS.WALLET);
      // // console.log("Fetched Bank Details:", res);
      setLoading(false);
      if (res?.data) {
        setFormData({
          acc_no: res?.data?.acc_no || "",
          ifsc_code: res?.data?.ifsc_code || "",
          acc_holder: res?.data?.acc_holder || "",
          upi_type: res?.data?.upi_type || "",
          upi_id: res?.data?.upi_id || "",
        });
        set("bank_obj", {
          acc_no: res?.data?.acc_no || "",
          ifsc_code: res?.data?.ifsc_code || "",
          acc_holder: res?.data?.acc_holder || "",
          upi_type: res?.data?.upi_type || "",
          upi_id: res?.data?.upi_id || "",
        });
        setQrImages(res?.data?.qrcode);
        if (
          res?.data?.acc_no ||
          res?.data?.ifsc_code ||
          res?.data?.acc_holder ||
          res?.data?.upi_type ||
          res?.data?.upi_id
        ) {
          setIsEditable(false);
        }
        if (res?.data?.qrcode) {
          setIsEditableQr(true);
        }
        setLoading(false);
      }
      if (res?.data === null) {
        setIsEditable(true);
      }

      if (res?.data === null) {
        setIsEditableQr(false);
        set("bank_obj", {
          acc_no: "",
          ifsc_code: "",
          acc_holder: "",
          upi_type: "",
          upi_id: "",
        });
      }

      if (res?.data?.acc_no === null) {
        setIsEditable(true);
      }

      if (res?.data?.qrcode === null) {
        setIsEditableQr(false);
      }
    } catch (err) {
      console.error("Error fetching bank details:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBankDetails();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();

    if (!isEditable) {
      Toast("Details already exist and cannot be edited");
      return;
    }

    // ✅ Field Validations
    if (!formData.acc_no.trim()) {
      Toast("Please enter your Account Number");
      return;
    }
    if (!/^\d{9,18}$/.test(formData.acc_no)) {
      Toast("Account Number should be between 9 to 18 digits");
      return;
    }

    if (!formData.ifsc_code.trim()) {
      Toast("Please enter IFSC Code");
      return;
    }
    // if (formData.ifsc_code) {
    //     Toast("Please enter a valid IFSC Code (e.g. HDFC0001234)");
    //     return;
    // }

    if (!formData.acc_holder.trim()) {
      Toast("Please enter Account Holder Name");
      return;
    }
    if (!/^[A-Za-z ]+$/.test(formData.acc_holder)) {
      Toast("Account Holder Name should contain only alphabets");
      return;
    }

    if (!formData.upi_type.trim()) {
      Toast("Please select your UPI Type");
      return;
    }

    if (!formData.upi_id.trim()) {
      Toast("Please enter your UPI ID");
      return;
    }
    // if (!/^[\w.-]+@[\w.-]+$/.test(formData.upi_id)) {
    //     Toast("Please enter a valid UPI ID (e.g. username@bank)");
    //     return;
    // }

    setIsLoading(true);
    try {
      const res = await post(URLS.WALLET, formData);
      // // console.log("Response:", res);

      if (res.status === "success") {
        Toast(res.message || "Wallet details added successfully!");
        setIsEditable(false);
        fetchBankDetails();
      }
    } catch (err) {
      console.error("Error adding wallet:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirm = async () => {
    if (!qrImages) {
      Toast("Please upload a QR code image before confirming");
      return;
    }

    setIsLoading2(true);

    try {
      const formDataImg = new FormData();
      if (qrImages?.name) {
        formDataImg.append("qrcode", qrImages);
      }
      const res = await post(URLS.QRCODE, formDataImg);

      // // console.log("Response:", res);

      if (res.status === "success") {
        Toast("QR Code uploaded successfully!");
        setIsEditableQr(true);
        setIsLoading2(false);
        fetchBankDetails();
      }
    } catch (err) {
      console.error("Error adding wallet:", err);
      setIsLoading2(false);
      Toast("Failed to save wallet details");
    } finally {
      setIsLoading2(false);
    }
  };

  // useEffect(() => {
  //   const walletRef = ref(db, `clients/wallet/${userId}`);

  //   const handleWallet = (snapshot) => {
  //     const data = snapshot.val();
  //     setTotalWallet(data?.wallet_amount ?? 0);
  //   };

  //   // Attach listeners
  //   onValue(walletRef, handleWallet);

  //   // Cleanup on unmount
  //   return () => {
  //     off(walletRef, "value", handleWallet);
  //   };
  // }, [userId]);

  // Inject cropper styles
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = cropperStyles;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Initialize cropper when modal opens
  useEffect(() => {
    if (cropperModal && cropperImage && cropperImageRef.current) {
      const cropper = new Cropper(cropperImageRef.current, {
        aspectRatio: 1,
        viewMode: 1,
        dragMode: "move",
        autoCropArea: 0.8,
        restore: false,
        guides: true,
        center: true,
        highlight: false,
        cropBoxMovable: true,
        cropBoxResizable: true,
        toggleDragModeOnDblclick: false,
      });
      setCropperInstance(cropper);
    }
  }, [cropperModal, cropperImage]);

  // ✅ Crop and save image
  const handleCrop = () => {
    if (cropperInstance) {
      const croppedCanvas = cropperInstance.getCroppedCanvas({
        width: 300,
        height: 300,
        fillColor: "#fff",
        imageSmoothingEnabled: true,
        imageSmoothingQuality: "high",
      });

      if (croppedCanvas) {
        croppedCanvas.toBlob(
          (blob) => {
            if (blob) {
              const fileName = `qr_${Date.now()}.png`;
              const file = new File([blob], fileName, { type: "image/png" });

              if (croppingFor === "qr1") {
                setQrImages(file);
                setCheck(true);
              }

              setCropperModal(false);
              setCropperImage(null);
              setCroppingFor(null);

              if (cropperInstance) {
                cropperInstance.destroy();
                setCropperInstance(null);
              }

              Toast("Image cropped successfully!");
            }
          },
          "image/png",
          0.95,
        );
      }
    }
  };

  // ✅ Cancel cropping
  const handleCancelCrop = () => {
    setCropperModal(false);
    setCropperImage(null);
    setCroppingFor(null);

    if (cropperInstance) {
      cropperInstance.destroy();
      setCropperInstance(null);
    }

    if (fileInputRef1.current) fileInputRef1.current.value = "";

    Toast("Cropping cancelled");
  };

  return (
    <div className="dashRightView-foots ">
      <CustomScroll>
        <div
          style={{ paddingBottom: 80 }}
          className="containers_lists container_overalls pt-0"
        >
          {/* Wallet Header */}
          <div
            className="d-flex ac-jb pb-2"
            style={{ borderBottom: "2px solid #D9D9D9", paddingTop: 10 }}
          >
            <div className="d-flex ac-jb">
              <MaskIcon src={wallet} height={16} width={16} alt="icon" />
              <p style={{ color: "#8F0D3d" }} className="f4 fs-lg-18 ms-2">
                WALLET BALANCE
              </p>
            </div>
            <p style={{ color: "#8F0D3d" }} className="f3 fs-lg-18 ">
              ₹ {totalWallet}
            </p>
          </div>

          {/* Account Details */}
          <div className="d-flex ac-js mt-2">
            <MaskIcon src={accWallet} height={16} width={16} alt="icon" />
            <p style={{ color: "#8F0D3d" }} className="f4 fs-lg-18 ms-2">
              ACCOUNT DETAILS
            </p>
          </div>

          {/* Account No */}
          <div className="form-group text-start my-3 mb-4">
            <p style={{ fontWeight: 600 }} className="mb-1 f3 primary">
              Account No
            </p>
            <input
              onChange={(e) => {
                const value = e.target.value.slice(0, 16);
                handleChange({ target: { name: "acc_no", value } });
              }}
              name="acc_no"
              type="number"
              placeholder="Enter Account Number"
              className={`input-box ${!isEditable ? "placeholder-gray" : "placeholder-black"
                }`}
              value={formData?.acc_no}
              disabled={!isEditable}
            />
          </div>

          {/* IFSC */}
          <div className="form-group text-start my-3 mb-4">
            <p style={{ fontWeight: 600 }} className="mb-1 f3 primary">
              IFSC Code
            </p>
            <input
              onChange={(e) =>
                handleChange({
                  target: {
                    name: e.target.name,
                    value: e.target.value.toUpperCase(),
                  },
                })
              }
              type="text"
              name="ifsc_code"
              placeholder="Enter IFSC Code"
              className={`input-box ${!isEditable ? "placeholder-gray" : "placeholder-black"
                }`}
              value={formData.ifsc_code}
              disabled={!isEditable}
              maxLength={11}
            />
          </div>

          {/* Account Holder */}
          <div className="form-group text-start my-3 mb-4">
            <p style={{ fontWeight: 600 }} className="mb-1 f3 primary">
              Account Holder Name
            </p>
            <input
              onChange={handleChange}
              type="text"
              placeholder="Enter Holder Name"
              className={`input-box ${!isEditable ? "placeholder-gray" : "placeholder-black"
                }`}
              name="acc_holder"
              value={formData.acc_holder}
              maxLength={60}
              disabled={!isEditable}
            />
          </div>

          {/* UPI Type */}
          <div
            style={{ paddingBottom: "0.5rem", paddingTop: 5 }}
            className=" d-flex ac-js gap-3"
          >
            <div className="payment d-flex gap-3" style={{ cursor: "pointer" }}>
              {["gpay", "phonepe", "paytm", "other"].map((type) => (
                <img
                  key={type}
                  src={
                    type === "gpay"
                      ? gpay
                      : type === "phonepe"
                        ? phonepay
                        : type === "paytm"
                          ? paytm
                          : otherbg
                  }
                  className={`upi-icon ${formData.upi_type === type ? "selected" : ""
                    }`}
                  onClick={() =>
                    isEditable && setFormData({ ...formData, upi_type: type })
                  }
                  alt={type}
                />
              ))}
            </div>
          </div>

          {/* UPI ID */}
          <div className="form-group text-start my-3 mb-4">
            <p style={{ fontWeight: 600 }} className="mb-1 f3 primary">
              UPI ID
            </p>
            <input
              onChange={handleChange}
              type="text"
              name="upi_id"
              placeholder="Enter your UPI ID"
              className={`input-box ${!isEditable ? "placeholder-gray" : "placeholder-black"
                }`}
              value={formData.upi_id}
              maxLength={30}
              disabled={!isEditable}
            />
          </div>

          {/* Add Button */}
          <div className="my-4">
            <button
              onClick={handleAdd}
              style={{
                backgroundColor: isEditable ? "#8F0D3d" : "#5D5D5D",
                cursor: isEditable ? "pointer" : "not-allowed",
              }}
              disabled={!isEditable || isLoading}
              className="add-button f3 white"
            >
              {isEditable ? (
                isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  "Confirm"
                )
              ) : (
                "Added"
              )}
            </button>
          </div>

          {/* QR Upload */}
          <div className="mt-5 text-center QRCode_container2">
            <input
              id="qrCodeUpload"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
              disabled={isEditableQr}
            />

            <label
              htmlFor="qrCodeUpload"
              className=" QRcode sec"
              style={{
                display: "inline-block",
                cursor: !isEditableQr ? "pointer" : "not-allowed",
                color: "#555",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "700",
                overflow: "hidden",
                position: "relative",
              }}
            >
              {qrImages ? (
                <img
                  src={
                    qrImages instanceof File
                      ? URL.createObjectURL(qrImages)
                      : qrImages
                  }
                  alt="QR Code Preview"
                  style={{
                    width: "160px",
                    height: "160px",
                    objectFit: "contain",
                    borderRadius: "10px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                  }}
                />
              ) : qrImage ? (
                <>
                  <img
                    src={
                      typeof qrImage === "string"
                        ? qrImage
                        : URL.createObjectURL(qrImage)
                    }
                    alt="QR Code Preview"
                    style={{
                      width: "160px",
                      height: "160px",
                      objectFit: "contain",
                      borderRadius: "10px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      zIndex: "99",
                      right: 33,
                      top: 58,
                      color: "rgb(177 177 177)",
                      fontWeight: 600,
                      fontFamily: "f1",
                    }}
                  >
                    Upload Your <br /> QR Code
                  </span>
                </>
              ) : (
                <span
                  style={{
                    display: "inline-block",
                    color: "#777",
                    fontWeight: "600",
                    padding: "20px",
                  }}
                >
                  No QR Code Available
                </span>
              )}
            </label>
          </div>

          {/* Confirm Button */}
          <div className="my-4">
            <button
              onClick={handleConfirm}
              className="add-button f3  fs-xl-15 fs-xxl-17 white"
              disabled={isEditableQr || isLoading2}
              style={{
                backgroundColor: !isEditableQr ? "#8F0D3d" : "#5D5D5D",
                cursor: !isEditableQr ? "pointer" : "not-allowed",
              }}
            >
              {!isEditableQr ? (
                isLoading2 ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  "Confirm"
                )
              ) : (
                "Added"
              )}
            </button>
          </div>
        </div>
      </CustomScroll>
      {loading && <Loader />}
      {/* Cropper Modal */}
      {cropperModal && (
        <div className="img-popup-design" style={{ zIndex: 9999 }}>
          <div
            className="img-popup"
            style={{ maxWidth: "90%", width: "800px", maxHeight: "90vh" }}
          >
            <h4 className="f3 primary mb-3">Crop QR Code</h4>

            <div
              className="cropper-container"
              style={{
                width: "100%",
                height: "400px",
                marginBottom: "14px",
                backgroundColor: "#f5f5f5",
              }}
            >
              <img
                ref={cropperImageRef}
                src={cropperImage}
                alt="Crop preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  display: "block",
                }}
                crossOrigin="anonymous"
              />
            </div>

            <div className="cropper-controls d-flex justify-content-center gap-3 mt-1">
              <button
                onClick={handleCancelCrop}
                className="no-btn f3"
                style={{ minWidth: "120px", padding: "10px 20px" }}
              >
                Cancel
              </button>
              <button
                onClick={handleCrop}
                className="yes-btn f3"
                style={{ minWidth: "120px", padding: "10px 20px" }}
              >
                Crop & Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Wallet;
